import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import appcolors from "../../constants/Colors";

const DynamicTabsDrawer = ({
  primaryHeading,
  tabs,
  activeTab,
  handleChangeTab,
}) => {
  return (
    <Paper sx={{ borderRadius: "6px", p: 2,height:"100%" }}>
      <Typography
        variant="h1"
        fontSize={"1.1rem"}
        textAlign={"center"}
        fontWeight={600}
      >
        {primaryHeading}
      </Typography>
      <Stack mt={2} gap={"2px"}>
        {tabs.map((tab) => (
          <Box
            key={tab.value}
            p={1}
            sx={{ cursor: "pointer" }}
            borderRadius={1}
            bgcolor={activeTab === tab.value ? appcolors.primaryLight : null}
            onClick={() => handleChangeTab(tab.value)}
          >
            <Typography variant="body1" fontSize={"0.875rem"}>
              {tab.label}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export default DynamicTabsDrawer;
